import React from 'react'
import './Carousel.css'
import Slider from "react-slick";
import { Link } from 'react-router-dom';

import grip_logo from '../../assets/logos/logo-1.png'
import stem_logo from '../../assets/logos/logo-3.png'
import parl_logo from "../../assets/logos/logo-4.png"
import ug_anveshan_logo from "../../assets/logos/logo-2.png"
import tech_logo from "../../assets/logos/logo-5.png"
import changemakers_logo from "../../assets/logos/logo-6.png"

export default function Carousel(props) {

    const settings = {
        dots: false,
        fade: true,
        infinite: true,
        speed: 1200,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        pauseOnHover: false,
        cssEase: "cubic-bezier(0.86, 0, 0.07, 1)",
    };

    const handleScroll = () => {
        window.scrollBy({ top: window.innerHeight, behavior: "smooth" });
    };
    
    const images = props.images;

    return (
        <section>
            <div className="carousel">
                <Slider {...settings}>
                    {images.map((image, index) => (
                        <div>
                            <img src={image} className="carousel_image" alt="carousel" />
                        </div>
                    ))}
                </Slider>
                <h3>{props.title}</h3>
                <h1>{props.heading}</h1>
                {/* <button onClick={handleScroll}>Explore</button> */}
                <section className="home-overlay">
                    <Link to="/programs/grip" className="home-overlay-section">
                        <img src={grip_logo} alt="" />
                        <span>GRASSROOT INNOVATION PROGRAM</span>
                    </Link>
                    <Link to="/programs/stem-mentorship" className="home-overlay-section">
                        <img src={stem_logo} alt=""/>
                        <span>MANASVI: STEM MENTORSHIP PROGRAMME</span>
                    </Link>
                    <Link to="/programs/anveshan" className="home-overlay-section">
                        <img src={ug_anveshan_logo} alt=""/>
                        <span>ANVESHAN: INNOVATION AND EXPLORATION ACROSS DISCIPLINES</span>
                    </Link>
                    <Link to="/programs/government-connect" className="home-overlay-section">
                        <img src={parl_logo} alt=""/>
                        <span>ENGAGEMENT WITH PARLIAMENTARIANS</span>
                    </Link>
                    <Link to="/programs/sci-tech-spins" className="home-overlay-section">
                        <img src={tech_logo} alt=""/>
                        <span>SCI-TECH SPINS FOR SCHOOLS</span>
                    </Link>
                    <Link to="/programs/changemakers" className="home-overlay-section">
                        <img src={changemakers_logo} alt=""/>
                        <span>CHANGEMAKERS</span>
                    </Link>
                </section>
            </div>
        </section>
    )
}
